import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Turn any thrown value into a human-readable message for a toast (ticket
 * c55c5d60). Replaces the old `String(err)` pattern, which renders
 * "[object Object]" for plain objects and "Error: ..." prefixes for Errors.
 * Prefers a Supabase edge-function error body, then a message field, then a
 * sensible generic fallback.
 */
export function formatError(err: unknown, fallback = "Something went wrong. Please try again."): string {
  if (typeof err === "string") return err || fallback
  if (err && typeof err === "object") {
    const e = err as {
      context?: { message?: unknown; error?: unknown }
      message?: unknown
      error?: unknown
      error_description?: unknown
    }
    // Supabase FunctionsHttpError carries the edge fn's JSON body on `context`.
    if (typeof e.context?.message === "string" && e.context.message) return e.context.message
    if (typeof e.context?.error === "string" && e.context.error) return e.context.error
    if (typeof e.error_description === "string" && e.error_description) return e.error_description
    if (typeof e.message === "string" && e.message) return e.message
    if (typeof e.error === "string" && e.error) return e.error
  }
  return fallback
}
